import { StyleSheet } from 'react-native';
import { PROFILE_COLORS } from '../ProfileScreen/ProfileScreen.constants';

export const profileHeaderBarStyles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingTop: 6,
    paddingBottom: 6,
  },
  iconButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconButtonPressed: { opacity: 0.6 },
  iconButtonHover: { backgroundColor: PROFILE_COLORS.card },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: PROFILE_COLORS.text,
  },
});
